/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Cognos Analytics Home (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'baglass/app/plugins/MenuActionInterface',
	'baglass/core-client/js/core-client/utils/ClassFactory',
	'ca-content/glass/glass',
	'react',
	'react-dom'
], (MenuActionInterface, ClassFactory, Glass, React, ReactDOM) => {

	const CONTENT_PERSPECTIVE = 'content';
	const { MenuSlideout, ChevronRight32 } = Glass;
	const NAV_MENU_EVENTS = 'navmenu:slideout:open';

	class ContentMenuController extends MenuActionInterface {

		onSelectItem(context) {
			const key = this._getPluginKey(context.target.itemId);
			const glassContext = context.glassContext;
			if (key === 'content') {
				return glassContext.openAppView(CONTENT_PERSPECTIVE);
			}
		}

		onRenderItem(context) {
			const key = this._getPluginKey(context.target.itemId);
			const glassContext = context.glassContext;
			if (key === 'content') {
				const currentPerspective = glassContext.getCurrentPerspective();
				if (currentPerspective === CONTENT_PERSPECTIVE) {
					context.target.activeObject.addClass('isActive');
				}
			} else {
				this._renderSlideout(context);
			}
		}

		_getPluginKey(itemId) {
			const idTokens = itemId.split('.');
			return idTokens[idTokens.length - 1];
		}

		_renderSlideout(context) {
			const glassContext = context.glassContext;
			const $el = context.target.activeObject;
			const itemSpec = this._getItemSpec(context);
			const moduleId = itemSpec && itemSpec.options && itemSpec.options.content && itemSpec.options.content.module;

			if (moduleId) {
				this._renderRightIcon($el);
				this._loadModulePromise = ClassFactory.instantiate(moduleId, {
					itemSpec: context,
					glassContext: glassContext
				}).then(viewModule => {
					const initializationPromise = typeof viewModule.initialize === 'function' ? viewModule.initialize() : Promise.resolve();
					return initializationPromise.then(() => {
						if (!$el._newSlideout) {
							const $slideoutParent = $el.parents('.popover.ba-carbon-nav-menu');
							const $container = $('<div class="hamburger-menu-slideout-container"/>');
							$container.appendTo($slideoutParent);
							$el._newSlideout = ReactDOM.render(
								<MenuSlideout
									Glass={glassContext}
									viewModule={viewModule}
									onHidden={() => { $el.focus(); }}
								/>,
								$container[0]);
						}
					});
				}).then(() => {
					glassContext.getCoreSvc('.Events').on(NAV_MENU_EVENTS, (payload) => {
						if (payload.target !== context.target.itemId) {
							$el.removeClass('isActive');
							$el._newSlideout.closeSlideout();
						}
					});
					$('.ca-menuSlideout').on('click',evt => {
						if(evt.target && evt.target.classList.contains('react-resizable-handle')) {
							this._toggleSlideout(context, $el, glassContext, evt, false, false)
						}
					});
				})

				// Block default menu event handling so it doesn't dismiss
				$el.on('clicktap', this._toggleSlideout.bind(this, context, $el, glassContext));
				$el.on('keypress keyup', evt => { evt.preventDefault() && evt.stopPropagation(); });
				$el.on('keyup', evt => {
					const keycode = evt.keyCode || evt.which;
					if (keycode === 13 || keycode === 32) {
						this._toggleSlideout(context, $el, glassContext, evt, true /* setFocus */);
					}
				});
			}
		}

		_toggleSlideout(context, $el, glassContext, evt, setFocus = false, toggle = true) {
			evt.stopPropagation();
			evt.preventDefault();
			$el.blur();
			this._loadModulePromise.then(() => {
				glassContext.getCoreSvc('.Events').trigger(NAV_MENU_EVENTS, { target: context.target.itemId })
				setTimeout(() => {
					if(toggle) {
						this._toggleMenuActiveState($el);
						$el._newSlideout.toggleState(setFocus);
					}
				}, 0);
			});
		}

		_toggleMenuActiveState($el) {
			// todo: need to remove active state on all the siblings with glass menu api
			$el.toggleClass('isActive');
		}

		_renderRightIcon($el) {
			// todo: this should be handled by the glass menu api
			const $container = $('<div class="rightIcon-container" style="display: inline; float: right;"/>');
			$container.appendTo($el.children('.commonMenuLink'));
			ReactDOM.render(
				<ChevronRight32 className='chevronRightIcon' />,
				$container[0]);
		}

		_getItemSpec(context) {
			const menuId = context.target.itemId;
			const items = context.target.plugin.items;
			return items.filter((item) => { return item.id === menuId; })[0];
		}

		isItemVisible() {
			return true;
		}

	}

	return ContentMenuController;
});